var render, staticRenderFns
import script from "./TransitionHeight.vue?vue&type=script&lang=js&"
export * from "./TransitionHeight.vue?vue&type=script&lang=js&"
import style0 from "./TransitionHeight.vue?vue&type=style&index=0&id=7dbb13a4&scoped=true&lang=css&"
import style1 from "./TransitionHeight.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb13a4",
  null
  
)

component.options.__file = "TransitionHeight.vue"
export default component.exports